module.exports = __webpack_public_path__ + "img/_DSC4768.da95acf0.webp";